import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components/macro';

import Button from 'components/Button/Button';

export const TicketsPageStyled = styled.div`
  height: 100%;
`;

export const MessageWrapStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2.5rem 0;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin: 6.25rem 0;
    }
  `}
`;

export const FilterBtnStyled = styled(Button)`
  align-self: flex-start;
  margin: 1rem;
  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-top: -3rem;
    }
  `}
`;

export const HeaderBoxStyled = muiStyled(Box)(() => ({
  position: 'sticky',
  top: 0,
  zIndex: 15,
  backgroundColor: 'white',
}));

export const ContentWrapStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
  overflow-x: hidden;
  transition: 0.3s linear;
`;
